import React from "react";

import { FcSurvey } from "react-icons/fc";
import FooterwithoutLogin from "./footerwithoutLogin";

const PrivacyPolicyNew = () => {
  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xxl">
            <div className="page-header d-print-none">
              <div className="row align-items-center">
                <div className="col-md-12">
                  {/* <h2 className="page-title mb-1 text-center">
                    <FcSurvey className="fs-2  me-1" />
                   
                  </h2> */}
                  <h1
                    className="card-title mb-2 mt-2 text-center text-uppercase"
                    style={{ fontSize: "40px", fontWeight: "bold" }}
                  >
                      <FcSurvey className="me-1" style={{height:"40px", width:"40px"}}/>
                    Privacy Policy
                  </h1>
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="card mt-3">
              <div className="card-body" id="pdf-content">
                <h2>
                  <b>SECTION 1 – WHAT DO WE DO WITH YOUR INFORMATION?</b>
                </h2>
                <br></br>
                <p style={{fontSize:"1.1rem"}}>
                  When you purchase something from our store, as part of the
                  buying and selling process, we collect the personal
                  information you give us such as your name, address and email
                  address.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  When you browse our store, we also automatically receive your
                  computer’s internet protocol (IP) address in order to provide
                  us with information that helps us learn about your browser and
                  operating system.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  Email marketing (if applicable): With your permission, we may
                  send you emails about our store, new products and other
                  updates.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 2 – CONSENT</b>
                </h2>
                <br></br>
                <h3>How do you get my consent?</h3>
                <p style={{fontSize:"1.1rem"}}>
                  When you provide us with personal information to complete a
                  transaction, verify your credit card, place an order, arrange
                  for a delivery or return a purchase, we imply that you consent
                  to our collecting it and using it for that specific reason
                  only.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  If we ask for your personal information for a secondary
                  reason, like marketing, we will either ask you directly for
                  your expressed consent, or provide you with an opportunity to
                  say no.
                </p>
                <p>How do I withdraw my consent?</p>
                <p style={{fontSize:"1.1rem"}}>
                  If after you opt-in, you change your mind, you may withdraw
                  your consent for us to contact you, for the continued
                  collection, use or disclosure of your information, at anytime,
                  by contacting us at contact@kryzen.com or mailing us at:
                </p>
                <p style={{fontSize:"1.1rem"}}>Kryzen Biotech Pvt Ltd,</p>
                <p style={{fontSize:"1.1rem"}}>
                  #98, At. Po. Degaon, Taluka Wai, Satara, Maharashtra, India
                  412803.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 3 – DISCLOSURE</b>
                </h2>
                <br></br>
                <p style={{fontSize:"1.1rem"}}>
                  We may disclose your personal information if we are required
                  by law to do so or if you violate our Terms of Service.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 4 – THIRD-PARTY SERVICES</b>
                </h2>
                <br></br>
                <p style={{fontSize:"1.1rem"}}>
                  In general, the third-party providers used by us will only
                  collect, use and disclose your information to the extent
                  necessary to allow them to perform the services they provide
                  to us.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  However, certain third-party service providers, such as
                  payment gateways and other payment transaction processors,
                  have their own privacy policies in respect to the information
                  we are required to provide to them for your purchase-related
                  transactions.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  For these providers, we recommend that you read their privacy
                  policies so you can understand the manner in which your
                  personal information will be handled by these providers.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  In particular, remember that certain providers may be located
                  in or have facilities that are located a different
                  jurisdiction than either you or us. So if you elect to proceed
                  with a transaction that involves the services of a third-party
                  service provider, then your information may become subject to
                  the laws of the jurisdiction(s) in which that service provider
                  or its facilities are located.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  As an example, if you are located in China and your
                  transaction is processed by a payment gateway located in
                  India, then your personal information used in completing that
                  transaction may be subject to disclosure under Indian
                  legislation.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  Once you leave our store’s website or are redirected to a
                  third-party website or application, you are no longer governed
                  by this Privacy Policy or our website’s Terms of Service.
                </p>
                <p style={{fontSize:"1.1rem"}}>Links</p>
                <p style={{fontSize:"1.1rem"}}>
                  When you click on links on our store, they may direct you away
                  from our site. We are not responsible for the privacy
                  practices of other sites and encourage you to read their
                  privacy statements.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 5 – SECURITY</b>
                </h2>
                <br></br>
                <p style={{fontSize:"1.1rem"}}>
                  To protect your personal information, we take reasonable
                  precautions and follow industry best practices to make sure it
                  is not inappropriately lost, misused, accessed, disclosed,
                  altered or destroyed.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  If you provide us with your credit card information, the
                  information is encrypted using secure socket layer technology
                  (SSL) and stored with a AES-256 encryption. Although no method
                  of transmission over the Internet or electronic storage is
                  100% secure, we follow all PCI-DSS requirements and implement
                  additional generally accepted industry standards.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 6 – COOKIES</b>
                </h2>
                <br></br>
                <p style={{fontSize:"1.1rem"}}>
                  Here is a list of cookies that we use. We’ve listed them here
                  so you that you can choose if you want to opt-out of cookies
                  or not.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  _session_id, unique token, sessional, Allows us to store
                  information about your session (referrer, landing page, etc).
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  no data held, Persistent for 30 minutes from the last visit,
                  Used by our website provider’s internal stats tracker to
                  record the number of visits
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  no data held, expires midnight (relative to the visitor) of
                  the next day, Counts the number of visits to a store by a
                  single customer.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  cart, unique token, persistent for 2 weeks, Stores information
                  about the contents of your cart.
                </p>
                <p style={{fontSize:"1.1rem"}}>_secure_session_id, unique token, sessional</p>
                <p style={{fontSize:"1.1rem"}}>
                  storefront_digest, unique token, indefinite If the shop has a
                  password, this is used to determine if the current visitor has
                  access.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 7 – AGE OF CONSENT</b>
                </h2><br></br>
                <p style={{fontSize:"1.1rem"}}>
                  By using this site, you represent that you are at least the
                  age of majority in your state or province of residence, or
                  that you are the age of majority in your state or province of
                  residence and you have given us your consent to allow any of
                  your minor dependents to use this site.
                </p>
                <br></br>
                <hr></hr>
                <h2>
                  <b>SECTION 8 – CHANGES TO THIS PRIVACY POLICY</b>
                </h2><br></br>
                <p style={{fontSize:"1.1rem"}}>
                  We reserve the right to modify this privacy policy at any
                  time, so please review it frequently. Changes and
                  clarifications will take effect immediately upon their posting
                  on the website. If we make material changes to this policy, we
                  will notify you here that it has been updated, so that you are
                  aware of what information we collect, how we use it, and under
                  what circumstances, if any, we use and/or disclose it.
                </p>
                <p style={{fontSize:"1.1rem"}}>
                  If our store is acquired or merged with another company, your
                  information may be transferred to the new owners so that we
                  may continue to sell products to you.
                </p>
                <hr></hr>
                <h2>QUESTIONS AND CONTACT INFORMATION</h2>
                <p style={{fontSize:"1.1rem"}}>
                  If you would like to: access, correct, amend or delete any
                  personal information we have about you, register a complaint,
                  or simply want more information contact our Privacy Compliance
                  Officer at contact@kryzen.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin />
    </>
  );
};

export default PrivacyPolicyNew;
